import React from 'react';
import { Button } from '@chakra-ui/react';
import { Alert, AlertAction, AlertDescription, AlertTitle } from '../ui/Alert';

export interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function ErrorState({
  title = 'Não foi possível carregar os dados',
  description = 'Verifique a conexão e tente novamente.',
  onRetry,
  retryLabel = 'Tentar novamente',
}: ErrorStateProps) {
  return (
    <Alert variant="error">
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
      {onRetry && (
        <AlertAction>
          <Button size="sm" variant="outline" onClick={onRetry}>
            {retryLabel}
          </Button>
        </AlertAction>
      )}
    </Alert>
  );
}
